import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { 
  Container, Box, AppBar, Toolbar, Typography, Button,
  Drawer, List, ListItem, ListItemIcon, ListItemText,
  Divider
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import PeopleIcon from '@mui/icons-material/People';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const DRAWER_WIDTH = 240;

const AdminLayout: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Nexus-on Top - Admin
          </Typography>
          <Typography variant="body1" sx={{ mx: 2 }}>
            Hi, {user?.username}!
          </Typography>
          <Button color="inherit" onClick={handleLogout}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      
      <Drawer
        variant="permanent"
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: DRAWER_WIDTH, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto', mt: 2 }}>
          <List>
            <ListItem button onClick={() => navigate('/admin/users')}>
              <ListItemIcon><PeopleIcon /></ListItemIcon>
              <ListItemText primary="User Management" />
            </ListItem>
          </List>
          <Divider sx={{ my: 2 }} />
          <List>
            <ListItem button onClick={() => navigate('/')}>
              <ListItemIcon><ArrowBackIcon /></ListItemIcon>
              <ListItemText primary="Back to App" />
            </ListItem>
          </List>
        </Box>
      </Drawer>
      
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Container maxWidth="lg">
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
};

export default AdminLayout;